import { useTranslations } from "use-intl";
import { validateParams } from "@/shared/template-properties/utils/validate-properties";

export function useValidateProperties({
  properties,
}: {
  properties: string[];
}) {
  const t = useTranslations("Common");

  return validateParams(properties, t);
}
